<form class="w-100 h-100 form" [formGroup]="requirementForm" (ngSubmit)="sendData()" *ngIf="requirementStatus">
  <h4 class="text-center">Edición de estado de {{ requirementStatus.code }}</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12">
      <p style="font-size: 20px">El Estado actual de este requerimiento <b>{{requirementStatus.status}}</b></p>
      <h5>Por favor selecciona un nuevo estado para este requerimiento</h5>
    </div>
    <div class="col-12 mb-5">
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style" formControlName="statusId">
        <mat-button-toggle [value]="tag.id" *ngFor="let tag of availableStatus">{{tag.name}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Comentario</mat-label>
        <textarea matInput formControlName="comment" style="height: 200px"
                  placeholder="comentario"></textarea>
        <mat-error>Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="requirementForm.invalid">
      {{ requirementStatus.idStatus !== requirementForm.get('statusId').value ? 'Guardar con nuevo estado' : 'Guardar comentario'}}
    </button>
  </div>
</form>
